var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 45,
    viewBox: "0 0 17 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 1C15.1046 1 16 1.89543 16 3V32.9795C16 33.326 15.9102 33.6658 15.7402 33.9658L15.6621 34.0918L10.1621 42.3135C9.39485 43.4603 7.73796 43.496 6.91504 42.4209L6.83789 42.3135L1.33789 34.0918C1.11775 33.7627 1 33.3754 1 32.9795V3L1.01074 2.7959C1.113 1.78722 1.96435 1 3 1H14Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.6a47952ce9d67ca89adb3d39120253ac.svg";
export { ForwardRef as ReactComponent };